import React, { Fragment, memo, useEffect, useRef, useState } from "react";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import { Button, Grid, Tooltip, Typography } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import CopyButton from "../../../common/buttons/CopyButton";

interface CertDialogProps {
  title: string;
  certData?: string;
}

const CertDialog = ({ title, certData }: CertDialogProps) => {
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");

  const handleClickOpen = (scrollType: DialogProps["scroll"]) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <Fragment>
      <Tooltip title="Click to view" arrow>
        <Button
          variant="outlined"
          size="medium"
          color="primary"
          onClick={handleClickOpen("paper")}
        >
          {title}
        </Button>
      </Tooltip>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          handleClose();
        }}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          <Grid container>
            <Grid item xs={11}>
              {title}
            </Grid>
            <Grid item xs={1}>
              <CopyButton code={certData} />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <Typography
              variant="body1"
              align="left"
              style={{
                wordWrap: "break-word",
                fontFamily: "Monospace",
                whiteSpace: "break-spaces",
              }}
            >
              {certData}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};
export default memo(CertDialog);
